import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import authStore from '../../auth/auth-store'
import setStatementQuery from './set-statement-query'
import feedStore from '../../feed/feed-store'

export default async function toggleJybedByMe (context: BareActionContext<StatementState, RootState>) {
    const form = statementStore.state.statementSearchForm
    form.consideredByMe = false
    form.ignoredByMe = false
    form.notReactedByMe = false

    setStatementQuery(context)

    return
}
